import { render } from "./WordListRecall.vue?vue&type=template&id=66e9d29a&scoped=true"
import script from "./WordListRecall.vue?vue&type=script&lang=js"
export * from "./WordListRecall.vue?vue&type=script&lang=js"

import "./WordListRecall.vue?vue&type=style&index=0&id=66e9d29a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e9d29a"]])

export default __exports__